module.exports = __webpack_public_path__ + "media/3-result-5-2-2.mp3";